import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { errors, JourneysCreationTypeEnum, yupLocalized } from "@ryde/shared";

import { JourneyDuplicateFormFieldsEnum } from "./journey-duplicate.models";

export const useJourneyDuplicateResolver = () => {
  const { t } = useTranslation();

  const journeyDuplicateFormValidationSchema = useMemo(() => {
    return {
      [JourneyDuplicateFormFieldsEnum.Name]: yupLocalized.string().required(),
      [JourneyDuplicateFormFieldsEnum.CreationSource]: yupLocalized
        .string()
        .oneOf(Object.values(JourneysCreationTypeEnum))
        .required(),

      [JourneyDuplicateFormFieldsEnum.DayType]: yupLocalized
        .array()
        .of(yupLocalized.number().optional())
        .min(0)
        .optional(),

      [JourneyDuplicateFormFieldsEnum.DayGroup]: yupLocalized
        .array()
        .of(yupLocalized.number().optional())
        .min(0)
        .optional(),

      [JourneyDuplicateFormFieldsEnum.DateFrom]: yupLocalized
        .string()
        .required()
        .test(
          "is-valid-dateFrom",
          t("errors.validation.invalidDate"),
          value => !!value && dayjs(value).isValid(),
        )
        .test(
          "before-dateTo",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          function (value) {
            const { dateTo } = this.parent;
            if (!value || !dateTo) {
              return true;
            }
            return (
              dayjs(value).isBefore(dayjs(dateTo)) ||
              dayjs(value).isSame(dayjs(dateTo))
            );
          },
        ),

      [JourneyDuplicateFormFieldsEnum.DateTo]: yupLocalized
        .string()
        .required()
        .test(
          "is-valid-dateTo",
          t("errors.validation.invalidDate"),
          value => !!value && dayjs(value).isValid(),
        )
        .test(
          "after-dateFrom",
          t(errors.validation.endTimeMustBeGreaterThenStartTime),
          function (value) {
            const { dateFrom } = this.parent;
            if (!value || !dateFrom) {
              return true;
            } // skip if missing
            return (
              dayjs(value).isAfter(dayjs(dateFrom)) ||
              dayjs(value).isSame(dayjs(dateFrom))
            );
          },
        ),
    };
  }, [t]);

  return { journeyDuplicateFormValidationSchema };
};
